import { create } from 'zustand';
import { useSelectionStore } from './selection.store';

interface BookState {
  activeBookId: string | null;
  activeChapterId: string | null;
  dirty: boolean;
  lastSavedAt: number | null;
  setActiveBook: (id: string | null) => void;
  setActiveChapter: (id: string | null) => void;
  setDirty: (dirty: boolean) => void;
  markSaved: () => void;
}

export const useBookStore = create<BookState>((set) => ({
  activeBookId: null,
  activeChapterId: null,
  dirty: false,
  lastSavedAt: null,
  setActiveBook: (id) => {
    // A stale paragraph selection from the previous book would point at a
    // paragraph that no longer exists in the new context.
    useSelectionStore.getState().select(null);
    set({ activeBookId: id, activeChapterId: null });
  },
  setActiveChapter: (id) => {
    // Clear the paragraph selection on chapter switch; the editor route's
    // auto-select effect re-seeds it with the first paragraph of the new
    // chapter once its list loads.
    useSelectionStore.getState().select(null);
    set({ activeChapterId: id });
  },
  setDirty: (dirty) => set({ dirty }),
  markSaved: () => set({ dirty: false, lastSavedAt: Date.now() }),
}));
